import React from "react";
import "./OrgCommittee.css";
import { Profile } from "../Profile";

export const OrgCommittee = () => {
  const profilesGeneral = [
    {
      title: "Prof",
      firstName: "Dirk",
      surname: "Pesch",
      university: "University College Cork",
      bio: "https://research.ucc.ie/profiles/D005/dirk.pesch@ucc.ie",
      image: "./images/profiles/Dirk.png",
      linkedin: "https://www.linkedin.com/in/dirk-pesch-a05b146/",
      //twitter: "https://x.com/dirkpesch",
      email: "dirk.pesch@ucc.ie",
    },

    {
      title: "Prof",
      firstName: "Laura",
      surname: "Barnes",
      university: "University of Virginia",
      bio: "https://engineering.virginia.edu/faculty/laura-barnes",
      image: "./images/profiles/LauraBarnes.webp",
      linkedin: "https://www.linkedin.com/in/lauraebarnes/",
      twitter: null,
      email: "lb3dp@virginia.edu",
    },
  ];

  const profilesProgramme = [
    {
      title: "Prof",
      firstName: "Siobhán",
      surname: "Clarke",
      university: "Trinity College Dublin",
      bio: "https://www.scss.tcd.ie/siobhan.clarke/",
      image: "./images/profiles/Clarke.jpg",
      linkedin:
        "https://www.linkedin.com/in/siobhan-clarke-59b0132/?originalSubdomain=ie",
      //twitter: "https://x.com/sclarketcd?lang=en",
      email: "siobhan.clarke@tcd.ie",
    },
    {
      title: "Dr",
      firstName: "Franca",
      surname: "Delmastro",
      university: "CNR, Italy",
      bio: "http://cnd.iit.cnr.it/fdelmastro/",
      image: "./images/profiles/franca.png",
      linkedin:
        "https://www.linkedin.com/in/francadelmastro/?originalSubdomain=it",
      email: "franca.delmastro@iit.cnr.it",
    },
  ];

  const profilesLocal = [
    {
      title: "Dr",
      firstName: "Andrea",
      surname: "Visentin",
      university: "University College Cork",
      bio: "https://research.ucc.ie/profiles/D005/andrea.visentin@ucc.ie",
      image: "./images/profiles/Visentin.jpg",
      linkedin:
        "https://www.linkedin.com/in/andrea-visentin-a4b9a585/?originalSubdomain=ie",
      //twitter: "https://x.com/andvise?lang=en",
      email: "andrea.visentin@ucc.ie",
    },
    {
      title: "Dr",
      firstName: "Sourabh",
      surname: "Bharti",
      university: "Munster Technological University",
      bio: null,
      image: "./images/profiles/Bharti.jpg",
      linkedin:
        "https://www.linkedin.com/in/sourabh-bharti-0a284649/?originalSubdomain=ie",
      email: "Sourabh.Bharti@mtu.ie",
    },
  ];

  const profilesPublications = [
    {
      title: "Dr",
      firstName: "Sunyanan",
      surname: "Choochotkaew",
      university: "IBM Research",
      bio: "https://research.ibm.com/people/sunyanan-choochotkaew",
      image: "./images/profiles/Sunyanan.webp",
      linkedin:
        "https://www.linkedin.com/in/sunyanan-choochotkaew-233a50107/?originalSubdomain=jp",
      twitter: null,
      email: "Sunyanan.Choochotkaew1@ibm.com",
    },
    {
      title: "Dr",
      firstName: "Federico",
      surname: "Montori",
      university: "University of Bologna, Italy",
      bio: "https://www.unibo.it/sitoweb/federico.montori2/en",
      image: "./images/profiles/Montori.png",
      linkedin:
        "https://www.linkedin.com/in/federico-montori/?originalSubdomain=it",
      email: "federico.montori2@unibo.it",
    },
  ];

  const profilesWorkshop = [
    {
      title: "Dr",
      firstName: "Susan",
      surname: "Rea",
      university: "Munster Technological University",
      bio: "https://www.nimbus.cit.ie/researchers/dr-susan-rea/",
      image: "./images/profiles/SusanR.png",
      linkedin:
        "https://www.linkedin.com/in/susan-rea-nimbus-mtu/?originalSubdomain=ie",
      twitter: null,
      email: "susan.rea@mtu.ie",
    },
    {
      title: "Prof",
      firstName: "Jin",
      surname: "Nakazawa",
      university: "Keio University, Japan",
      bio: "https://www.sfc.keio.ac.jp/faculty_profile/en/list/EI/jin-nakazawa.html",
      image: "./images/profiles/jin.jpg",
      linkedin: "https://www.linkedin.com/in/jin-nakazawa-a5b8b25b/",
      email: "jin@sfc.keio.ac.jp",
    },
  ];

  const profilesPanel = [
    {
      title: "Prof",
      firstName: "Niki",
      surname: "Trigoni",
      university: "University of Oxford, UK ",
      bio: "https://www.cs.ox.ac.uk/people/niki.trigoni/",
      image: "./images/profiles/Trigoni.png",
      linkedin:
        "https://www.linkedin.com/in/professor-niki-trigoni-freng-279855a/?originalSubdomain=uk",
      twitter: null,
      email: "niki.trigoni@cs.ox.ac.uk",
    },
  ];

  const profilesTutorial = [
    {
      title: "Dr",
      firstName: "Fabrizio",
      surname: "De Vita",
      university: "University of Messina, Italy",
      bio: "https://archivio.unime.it/it/persona/fabrizio-de-vita/curriculum",
      image: "./images/profiles/fabrizio.jpg",
      linkedin: null,
      twitter: null,
      email: "fabrizio.devita@unime.it",
    },
    {
      title: "Dr",
      firstName: "Aisling",
      surname: "O'Driscoll",
      university: "University College Cork",
      bio: "https://www.ucc.ie/en/compsci/people/odriscolldraisling/",
      image: "./images/profiles/AislingO.png",
      linkedin:
        "https://www.linkedin.com/in/aislingodriscoll/?originalSubdomain=ie",
      email: "aisling.odriscoll@ucc.ie",
    },
  ];

  const profilesPoster = [
    {
      title: "Dr",
      firstName: "Nasibeh",
      surname: "Zohrabi",
      university: "Penn State Brandywine, USA",
      bio: "https://www.brandywine.psu.edu/person/nasibeh-zohrabi",
      image: "./images/profiles/Nasibeh.webp",
      linkedin: "https://www.linkedin.com/in/nasibehzohrabi/",
      twitter: null,
      email: "nmz5171@psu.edu",
    },
    {
      title: "Dr",
      firstName: "Francesca",
      surname: "Righetti",
      university: "University of Pisa, Italy",
      bio: "http://for.unipi.it/francesca_righetti/",
      image: "./images/profiles/Francesca.jpg",
      linkedin:
        "https://www.linkedin.com/in/francescarighetti/?originalSubdomain=it",
      email: "francesca.righetti@unipi.it",
    },
  ];

  const profilesPhD = [
    {
      title: "Prof",
      firstName: "Cormac",
      surname: "Sreenan",
      university: "University College Cork",
      bio: "https://www.ucc.ie/en/misl/people/csreenan/",
      image: "./images/profiles/Cormac.png",
      linkedin:
        "https://www.linkedin.com/in/cormac-sreenan-593b9520/?originalSubdomain=ie",
      //twitter: "https://x.com/sreenan_cj",
      email: "cormac.sreenan@ucc.ie",
    },
    {
      title: "Prof",
      firstName: "Stephan",
      surname: "Sigg",
      university: "Aalto University, Finland",
      bio: "https://www.aalto.fi/en/people/stephan-sigg",
      image: "./images/profiles/stephan.jpg",
      linkedin: null,
      email: "stephan.sigg@aalto.fi",
    },
  ];

  const profilesIndustry = [
    {
      title: "Dr",
      firstName: "Hana",
      surname: "Khamfroush",
      university: "University of Kentucky, USA",
      bio: "https://www.engr.uky.edu/directory/khamfroush-hana",
      image: "./images/profiles/Khamfroush.jpg",
      linkedin: "https://www.linkedin.com/in/hana-khamfroush-041aa427/",
      twitter: null,
      email: "khamfroush@uky.edu",
    },
    {
      title: "Dr",
      firstName: "Ahmed",
      surname: "Khalid",
      university: "Dell Technologies, Ireland",
      bio: "https://www.ucc.ie/en/misl/recentmislalumni/akhalid/",
      image: "./images/profiles/Khalid.jpg",
      linkedin:
        "https://www.linkedin.com/in/ahmed-khalid-10834217/?originalSubdomain=ie",
      email: "ahmed.khalid@dell.com",
    },
  ];

  const profilesPublicity = [
    {
      title: "Prof",
      firstName: "Flavio",
      surname: "DiMartino",
      university: "CNR, Italy",
      bio: "https://www.iit.cnr.it/flavio.dimartino/",
      image: "./images/profiles/flavio.jpg",
      linkedin:
        "https://www.linkedin.com/in/flavio-di-martino-403091112/?originalSubdomain=it",
      twitter: null,
      email: "flavio.dimartino@iit.cnr.it",
    },
    {
      title: "Dr",
      firstName: "Seokhyun",
      surname: "Chung",
      university: "University of Virginia",
      bio: "https://seokhyun-chung.github.io/",
      image: "./images/profiles/schung.jpg",
      email: "schung@virginia.edu",
      linkedin: "https://www.linkedin.com/in/seokhyun-chung-382928198",
    },
    {
      title: "Dr",
      firstName: "Congyu Peter",
      surname: "Wu",
      university: "Binghamton University",
      bio: "https://www.binghamton.edu/ssie/people/profile.html?id=congyu.wu",
      image: "./images/profiles/wu.jpg",
      email: "congyu.wu@binghamton.edu",
      linkedin: "https://www.linkedin.com/in/congyu-peter-wu-ph-d-52471b32/",
    },
    {
      title: "Dr",
      firstName: "Shantanu",
      surname: "Pal",
      university: "Deakin University, Australia",
      bio: "https://experts.deakin.edu.au/60615-shantanu-pal",
      image: "./images/profiles/shantu.png",
      email: "shantanu.pal@deakin.edu.au",
      linkedin: null,
    },
  ];

  const profilesFinancial = [
    {
      title: "Mr",
      firstName: "Luis",
      surname: "Gómez De Membrillera",
      university: "University College Cork",
      bio: "https://advance-crt.ie/#/people/luis-gomez",
      image: "./images/profiles/LuisG.png",
      linkedin:
        "https://www.linkedin.com/in/luis-g%C3%B3mez-de-membrillera-6a2340106/",
      //twitter: "https://x.com/dirkpesch",
      email: "lgomezdemembrillera@ucc.ie",
    },
  ];

  const profilesWeb = [
    {
      title: "Mr",
      firstName: "James",
      surname: "Duggan",
      university: "University College Cork",
      bio: "https://advance-crt.ie/#/people/james-duggan",
      image: "./images/profiles/JamesD.png",
      linkedin:
        "https://www.linkedin.com/in/james-duggan-80471b61/?originalSubdomain=ie",
      //twitter: "https://x.com/advance-crt",
      email: "james.duggan@ucc.ie",
    },
  ];

  return (
    <div className="profile-page-layout">
      <h2 className="title">General Co-Chairs</h2>

      <div className="profile-layout">
        {profilesGeneral.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Programme Co-Chairs</h2>

      <div className="profile-layout">
        {profilesProgramme.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Local Organising and Finance Chairs</h2>

      <div className="profile-layout">
        {profilesLocal.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Publications Co-Chairs</h2>

      <div className="profile-layout">
        {profilesPublications.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Workshop Co-Chairs</h2>

      <div className="profile-layout">
        {profilesWorkshop.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Panel Chair</h2>

      <div className="profile-layout">
        {profilesPanel.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Tutorial Co-Chairs</h2>

      <div className="profile-layout">
        {profilesTutorial.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Poster & Demo Co-Chairs</h2>

      <div className="profile-layout">
        {profilesPoster.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">PhD Forum Co-Chairs</h2>

      <div className="profile-layout">
        {profilesPhD.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Industry Track Co-Chairs</h2>

      <div className="profile-layout">
        {profilesIndustry.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Publicity and Social Media Co-Chairs</h2>

      <div className="profile-layout">
        {profilesPublicity.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Finance Chair</h2>

      <div className="profile-layout">
        {profilesFinancial.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
      <h2 className="title">Web Chair</h2>

      <div className="profile-layout">
        {profilesWeb.map(function (data) {
          return <Profile props={data} className="profile-item" />;
        })}
      </div>
    </div>
  );
};
